import { getSortedCollection, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useDeliveryEndpointApi } from "../../../../../common/api/orders-api/delivery-endpoint/useDeliveryEndpointApi";
import { DataHooksQueryKey } from "../../../../../common/data/data-hooks/DataHooksQueryKey";
import { DeliveryEndpoint, mapToDeliveryEndpoint } from "../../../../../common/types/DeliveryEndpoint";

export const useDeliveryEndpoints = (): SprintQueryResult<DeliveryEndpoint[]> => {
    const { getDeliveryEndpointsLookup } = useDeliveryEndpointApi();

    return useSprintQuery<DeliveryEndpoint[]>({
        queryKey: [DataHooksQueryKey.DeliveryEndpoints],
        queryFn: async (): Promise<DeliveryEndpoint[]> => {
            const response = await getDeliveryEndpointsLookup();
            const newItems = response.items.filter((item) => !!item).map(mapToDeliveryEndpoint);
            return getSortedCollection(newItems, "name");
        }
    });
};
